import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useVariables } from "~/repository/useVariables";
import { VariableDialog } from "./VariableDialog";

export const VariableDialogWrapper = ({ open, ...rest }) => {
  const { t } = useTranslation();
  const { data: variablesData } = useVariables("for-tasks", {
    enabled: open,
    staleTime: 60000,
  });

  const options = useMemo(
    () =>
      variablesData
        ? variablesData.map(({ name, description, can_be_modified }) => ({
            name: description,
            id: name,
            canBeModified: can_be_modified,
          }))
        : [{ name: t("Current date"), id: "date" }],
    [t, variablesData]
  );

  return (
    <VariableDialog
      open={open}
      options={options}
      {...rest}
    />
  );
};

VariableDialogWrapper.propTypes = {
  open: PropTypes.bool,
};
